goog.provide("shadow.js.shim.module$$carbon$icons_react$es$OverflowMenuVertical$default");
shadow.js.shim.module$$carbon$icons_react$es$OverflowMenuVertical$default = shadow.js.require(368, {}).default;
